import styled, { StyledFunction } from 'styled-components';

const StyledDiv: StyledFunction<{ color: string } & React.HTMLProps<HTMLInputElement>> = styled.div;
export const Dot = StyledDiv`
  display: inline-block;
  width: 8px;
  height: 8px;
  background-color: ${props => props.color};
  border-radius: 50%;
  margin-right: 8px;
`;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/Dot.tsx